import React from 'react';

import PlyrVideoPlayer from '@lyearn/shared/components/Players';
import { getVideoProviderDetails } from '@lyearn/shared/components/Players';

const VideoPlayer = React.forwardRef<
  typeof PlyrVideoPlayer,
  React.ComponentProps<typeof PlyrVideoPlayer>
>((props, ref) => {
  const { url } = props;
  // Guard against missing/invalid URLs to avoid `.match` on undefined inside helpers
  if (!url) {
    return null;
  }

  const { provider, videoId } = getVideoProviderDetails(url);

  return <PlyrVideoPlayer provider={provider} videoId={videoId} {...props} />;
});

export default VideoPlayer;
